export default __webpack_public_path__ + "static/media/quality-ok.bfe67c2f.svg";